export const validateSalaryRange = form => {
  const startSalary = form.getFieldValue("min_salary");
  const endSalary = form.getFieldValue("max_salary");

  if (
    (startSalary !== null && startSalary !== undefined && !endSalary) ||
    (!startSalary && startSalary !== 0 && endSalary)
  ) {
    form.setFields([
      {
        name: "salary_range",
        errors: [
          "Preencha ambos os valores da faixa salarial ou deixe ambos em branco."
        ]
      }
    ]);
    return;
  } else if (startSalary && endSalary && startSalary >= endSalary) {
    form.setFields([
      {
        name: "salary_range",
        errors: [
          "O valor inicial da faixa salarial não pode ser maior ou igual que o valor final."
        ]
      }
    ]);
  } else {
    form.setFields([
      {
        name: "salary_range",
        errors: []
      }
    ]);
  }
};
